import React from "react";
import "./SelectLicences.css";
import { useUserStore } from "../../contexts/userStore";
import Select from "../Select/Select";
import { useTranslation } from "react-i18next";

const SelectLicences = (props) => {
  const [selectedLicence, setSelectedLicence] = React.useState();
  const [optionsLicences, setOptionsLicences] = React.useState([]);
  const { licences } = useUserStore();
  const { t } = useTranslation();

  const storeLicences = async (licences) => {
    let licencesSelect = [];
    licences.forEach((licence) => {
      licencesSelect.push({ value: licence.id, text: licence.SN_equipment });
    });
    setOptionsLicences(licencesSelect);
  };

  React.useEffect(() => {
    storeLicences(licences);
  }, [licences]);

  React.useEffect(() => {
    setSelectedLicence(props.value?.id);
  }, [props.value]);

  const handleChangeLicence = (licenceId) => {
    const found = licences.find(
      (element) => element.id === parseInt(licenceId),
    ); //need licence obj, find in array
    setSelectedLicence(found.id);
    if (props.onChange) props.onChange(found);
  };

  return (
    <Select
      labelText={t("common.license")}
      required={props.required}
      disabled={props.disabled}
      className="select input-form"
      onChange={({ target }) => handleChangeLicence(target.value)}
      value={selectedLicence}
      options={optionsLicences}
    />
  );
};

export default SelectLicences;
